import { useContext, useEffect, useRef, useState } from 'react';
import { LDContext } from 'providers/launch-darkly';
import type { LDFlags } from 'providers/launch-darkly';

export const useLDFlag = <T>(flag: LDFlags, defaultValue: T): T | undefined => {
  const ldClient = useContext(LDContext);
  const defaultRef = useRef(defaultValue);
  // undefined = LD client present but not yet resolved; defaultValue = no client (LD disabled)
  const [value, setValue] = useState<T | undefined>(
    ldClient ? undefined : defaultValue
  );

  useEffect(() => {
    if (!ldClient) return;

    ldClient
      .waitUntilReady()
      .then(() => setValue(ldClient.variation(flag, defaultRef.current) as T))
      .catch(() => {
        setValue(defaultRef.current);
      });

    const handleChange = () =>
      setValue(ldClient.variation(flag, defaultRef.current) as T);

    ldClient.on(`change:${flag}`, handleChange);

    return () => {
      ldClient.off(`change:${flag}`, handleChange);
    };
  }, [ldClient, flag]);

  return value;
};
